import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { get, post } from "../../api/request";
import "./styles.css";

const nameOptions = [
  { key: "dad", label: "粑粑" },
  { key: "mom", label: "麻麻" },
  { key: "brother", label: "哥哥" },
  { key: "sister", label: "姐姐" },
  { key: "owner", label: "铲屎官" },
];

// 手机号正则验证（中国大陆11位手机号）
const validatePhone = (phone) => {
  const reg = /^1[3-9]\d{9}$/;
  return reg.test(phone);
};

const Invitation = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [relationship, setRelationship] = useState("owner");
  const [phone, setPhone] = useState("");
  const [code, setCode] = useState("");
  const [inviteDetails, setInviteDetails] = useState(null);
  // 新增：表单验证状态
  const [isFormValid, setIsFormValid] = useState(false);
  const [countdown, setCountdown] = useState(0);

  // 获取邀请详情
  useEffect(() => {
    async function fetchData() {
      try {
        const inviteCode = searchParams.get("code");
        console.log(inviteCode);
        if (inviteCode) {
          let result = await get("/api/pet/family/invite/detail", {
            code: inviteCode,
          });
          setInviteDetails(result.data);
        }
      } catch (error) {
        console.error("获取邀请详情失败：", error);
      }
    }
    fetchData();
  }, [searchParams]);

  useEffect(() => {
    if (inviteDetails) {
      console.log("inviteDetails: ", inviteDetails);
      let { status } = inviteDetails;
      if (status !== 0) {
        navigate("/invite/fail", { state: { status } });
      }
    }
  }, [inviteDetails]);

  // 监听手机号和验证码变化，实时验证
  useEffect(() => {
    // 验证条件：手机号格式正确 + 验证码非空
    const phoneValid = validatePhone(phone);
    const codeValid = code.trim().length > 0;
    setIsFormValid(phoneValid && codeValid);
  }, [phone, code]);

  // 选择身份
  const handleRoleSelect = (selectedRole) => {
    setRelationship(selectedRole);
  };

  // 提交表单
  const handleSubmit = async (e) => {
    e.preventDefault();
    // 双重验证，防止意外提交
    if (!isFormValid) return;
    console.log("提交信息：", { relationship, phone, code });
    let result = await post("/api/pet/family/invite/accept", {
      inviteCode: inviteDetails?.inviteCode,
      phone,
      relationship,
      code,
    });
    console.log("result", result);
    if (result.code === 0) {
      navigate("/invite/success");
    } else {
      alert(result.message);
    }
  };

  // 发送验证码（添加手机号验证）
  const handleSendCode = () => {
    if (!validatePhone(phone)) {
      alert("请输入正确的手机号！");
      return;
    }
    // 发送验证码的接口逻辑
    console.log("发送验证码到：", phone);
    post("/api/pet/family/sendSmsCode", { phone });
    // 示例：添加60秒倒计时逻辑

    if (countdown === 0) {
      setCountdown(60);
      // 调用发送验证码接口
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };
  if (!inviteDetails) return <div>加载中...</div>;
  return (
    <>
      <Helmet>
        <title>{`伴知宠 - ${inviteDetails?.pet.name}的日常`}</title>
        <meta
          property="og:title"
          content={`伴知宠 - ${inviteDetails?.pet.name}的可爱日常`}
        />
        <meta
          property="og:description"
          content={`${inviteDetails?.inviter.nickName}邀请您为${inviteDetails?.pet.name}定制专属“宠参谋”`}
        />
        <meta property="og:image" content={inviteDetails?.pet.photo} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="pet-advisor-page">
        {/* 头部区域 */}
        <header className="pet-header">
          <div className="header-text">
            <span>{inviteDetails?.inviter.nickName}邀请您</span>
            <span>为{inviteDetails?.pet.name}</span>
            <span>定制专属“宠参谋”</span>
          </div>
          <div className="pet-img"></div>
        </header>

        {/* 主体表单 */}
        <main className="pet-main">
          <div>
            <p className="role-title">你是宝贝的</p>
            <div className="role-buttons">
              {nameOptions.map((item) => (
                <button
                  key={item.key}
                  className={`role-btn ${
                    relationship === item.key ? "active" : ""
                  }`}
                  onClick={() => handleRoleSelect(item.key)}
                >
                  {item.label}
                </button>
              ))}
            </div>

            <form onSubmit={handleSubmit} className="form">
              {/* 手机号输入框 - 添加验证提示 */}
              <div className="input-wrapper">
                <input
                  type="tel"
                  placeholder="输入你的手机号，接受邀请"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className={`form-input ${
                    phone && !validatePhone(phone) ? "input-error" : ""
                  }`}
                  maxLength={11} // 限制输入长度
                />
                {/* 手机号错误提示 */}
                {phone && !validatePhone(phone) && (
                  <span className="error-tip">请输入正确的11位手机号</span>
                )}
              </div>

              {/* 验证码区域 */}
              <div className="code-group">
                <input
                  type="text"
                  placeholder="输入验证码"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  className={`form-input code-input ${
                    code && code.trim().length === 0 ? "input-error" : ""
                  }`}
                  maxLength={6} // 验证码通常6位
                />
                <button
                  type="button"
                  className={`send-code-btn ${
                    validatePhone(phone) ? "" : "btn-disabled"
                  }`}
                  onClick={handleSendCode}
                  disabled={!validatePhone(phone)}
                >
                  发送验证码
                </button>
              </div>

              {/* 提交按钮 - 根据验证状态控制样式和禁用 */}
              <button
                type="submit"
                className={`submit-btn ${isFormValid ? "" : "btn-disabled"}`}
                disabled={!isFormValid}
              >
                接受邀请
              </button>
            </form>
          </div>

          {/* <p className="expire-text">链接发出24小时后自动失效</p> */}
        </main>
      </div>
    </>
  );
};

export default Invitation;
